import { useState, useEffect } from "react";
import wifiOn from "@manta-scouting/shared-assets/wifi-on.png";
import wifiOff from "@manta-scouting/shared-assets/wifi-off.png";
import { OFFLINE_COPY } from "../lib/offline";

/**
 * Checks to see if device has internet, rechecks every couple seconds
 * @param {int} interval how often it runs
 * @param {String} version optional, the page its coming from
 * @returns {boolean} internet status
 */
export function useOnlineStatus(interval = 10000,version = "defaultpage") {
    const [online, setOnline] = useState(true);
    // The offline copy has no /api/ping of its own (lib/offline.js)
    const urls = [...(OFFLINE_COPY ? [] : ["/api/ping"]), "https://api.github.com", "https://example.com"]

    async function checkOnline() {
        if(navigator.onLine === false){ //initial check if connected to a network
            console.log("no wifiii " + version);
            setOnline(false);
            return false;
        }
        for (const url of urls) { //actual check for internet connection by if it can connect to actual page
            try {
                const res = await fetch(url, { method: "HEAD", cache: "no-cache", mode: "no-cors" });
                // If fetch succeeds without error, assume device is connected
                if(res){
                    if(online === false){
                        console.log("Wifi Connection Reestablished")
                    }
                    setOnline(true);
                }
                return;
            } catch {}
        }
        if(online === true){
            console.log("Wifi Connection Disconnected")
        }
        setOnline(false);
    }

    useEffect(() => {
        checkOnline();
        const id = setInterval(checkOnline, interval);
        return () => clearInterval(id);
    }, [interval]);

  return online;
}


function Wifi() {
  const online = useOnlineStatus();

  return (
    <div>
      <img style={{ filter: "var(--filter)" }} alt={online ? "wifiOn" : "wifiOff"} src={online ? wifiOn : wifiOff}/>
    </div>
  );
}
export default Wifi;